"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnePosMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class OnePosMapper {
    toDomain(result) {
        const hasError = !!lodash_1.default.get(result, "error");
        const isLoading = lodash_1.default.get(result, "loading");
        const pointOfSale = lodash_1.default.get(result, "data.getOnePos");
        return {
            hasError,
            isLoading,
            pointOfSale,
        };
    }
}
exports.OnePosMapper = OnePosMapper;
